/**
 * Curated list of industries offered as suggestions in the onboarding flow's
 * "Please select your industry" step. Kept intentionally short and broad —
 * founders can type a free-text value if their vertical isn't listed.
 *
 * Ordering: general/common at the top, more specialized further down. Values
 * are the same as labels for now; if we ever need a canonical id (e.g. for
 * server-side taxonomy) we can flip `value` to a slug without touching the UI.
 */
export interface IndustryOption {
  value: string;
  label: string;
}

export const INDUSTRIES: IndustryOption[] = [
  { value: 'SaaS', label: 'SaaS' },
  { value: 'Fintech', label: 'Fintech' },
  { value: 'E-commerce', label: 'E-commerce' },
  { value: 'Marketplace', label: 'Marketplace' },
  { value: 'Healthcare', label: 'Healthcare' },
  { value: 'Education', label: 'Education / EdTech' },
  { value: 'Real Estate', label: 'Real Estate / PropTech' },
  { value: 'Media', label: 'Media & Entertainment' },
  { value: 'Gaming', label: 'Gaming' },
  { value: 'Travel', label: 'Travel & Hospitality' },
  { value: 'Food', label: 'Food & Beverage' },
  { value: 'Logistics', label: 'Logistics & Supply Chain' },
  { value: 'Manufacturing', label: 'Manufacturing' },
  { value: 'Retail', label: 'Retail' },
  { value: 'Automotive', label: 'Automotive & Mobility' },
  { value: 'Energy', label: 'Energy & Sustainability' },
  { value: 'Agriculture', label: 'Agriculture / AgTech' },
  { value: 'Legal', label: 'Legal / LegalTech' },
  { value: 'HR', label: 'HR / Recruiting' },
  { value: 'Marketing', label: 'Marketing & Advertising' },
  { value: 'Productivity', label: 'Productivity & Collaboration' },
  { value: 'Developer Tools', label: 'Developer Tools' },
  { value: 'Security', label: 'Security & Privacy' },
  { value: 'AI/ML', label: 'AI / ML' },
  { value: 'Web3', label: 'Web3 / Crypto' },
  { value: 'Non-profit', label: 'Non-profit / Social Impact' },
  { value: 'Government', label: 'Government / Public Sector' },
  { value: 'Other', label: 'Other' },
];
